import { useEffect, useState } from "react";
import { Global } from "@emotion/react";
import { Box } from "@mui/material";
import { Root } from "../MUIStyled/Root";
import { Puller } from "../MUIStyled/Puller";
import { StyledBox } from "../MUIStyled/StyledBox";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import StormScenario from "../StormScenario/StormScenario";
import {
 comparedStormScenarioConfig,
 stormScenarioConfigMobile,
} from "../../../config/stormScenarioConfig";
import "./Sidebar.css";

/*
collapse
left side
loop through column of options

options props:
number 
a/b
title
options = [[optionName, optionIcon], [optionName1, optionIcon1], [optionName2, optionIcon2]]
*/

function createData(
 number,
 aB,
 title,
 thunk,
 options,
 stateKey,
 switchCase,
 availableKeyName,
 info
) {
 return {
  number,
  aB,
  title,
  thunk,
  options,
  stateKey,
  switchCase,
  availableKeyName,
  info,
 };
}

const SidebarMobileView = ({
 open,
 setOpen,
 checked,
 setChecked,
 btnClickOne,
 btnClickTwo,
 reductionStateOne,
 reductionStateTwo,
 withAdaptations,
 setWithAdaptations,
}) => {
 const [stormOptions, setStormOptions] = useState([]);
 const [scenarioContainerClassname, setScenarioContainerClassname] =
  useState("scenario-container");

 const toggleOpenOrClose = () => {
  if (open === true) {
   setOpen(false);
  } else {
   setOpen(true);
  }
 };

 const toggleDrawer = (isOpen) => (event) => {
  if (
   event &&
   event.type === "keydown" &&
   (event.key === "Tab" || event.key === "Shift")
  ) {
   return;
  }
  setOpen(isOpen);
 };

 useEffect(() => {
  let opts = stormScenarioConfigMobile.map((opt) =>
   createData(
    opt.number,
    opt.aB,
    opt.title,
    opt.thunk,
    opt.options,
    opt.stateKey,
    opt.switchCase,
    opt.availableKeyName,
    opt.info
   )
  );
  setStormOptions(opts);
 }, []);

 useEffect(() => {
  if (!!checked) {
   setScenarioContainerClassname("scenario-container-compare");
  } else {
   setScenarioContainerClassname("scenario-container");
  }
 }, [checked]);

 return (
  <>
   <div
    className={
     open === true ? "sidebar-puller-open-ios" : "sidebar-puller-closed-ios"
    }
   >
    <Puller onClick={toggleDrawer(true)} />
   </div>
   <div>
    <Root>
     <CssBaseline />
     <Global
      // change height to manipulate how far up the puller goes
      styles={{
       ".MuiDrawer-root > .MuiPaper-root": {
        height: `calc(100% - 140px)`,
        width: "100vw",
        overflow: "visible",
        overflowX: "none",
       },
      }}
     />
     <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      swipeAreaWidth={60}
      disableSwipeToOpen={false}
      ModalProps={{
       keepMounted: true,
      }}
     >
      <StyledBox
       sx={{
        backgroundColor: `#0b79bf`,
        position: "absolute",
        top: -60,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        visibility: "visible",
        width: "100vw",
        borderBottom: "1px solid white",
       }}
      >
       <Puller
        sx={{
         mb: "10px",
         color: "text.secondary",
        }}
        onClick={toggleOpenOrClose}
       />

       <div
        className={
         open === true
          ? "adaptations-buttons-open-ios"
          : "adaptations-buttons-closed-ios"
        }
       >
        {/* show when bottom drawer is open/closed  */}
        {open === true ? (
         <>
          <Typography
           sx={{
            py: "10px", //  1
            mb: "0px",
            color: "text.secondary",
           }}
          ></Typography>
          <div className="close-ios-drawer">
           <Typography
            sx={{
             py: 1,
             mb: "0px",
             color: "white",
             // color: "text.secondary",
            }}
           >
            Update Scenario
           </Typography>
          </div>
         </>
        ) : (
         <div className="update-scenario-closed">
          <Typography
           sx={{
            color: "white",
           }}
          >
           Update Scenario
          </Typography>
         </div>
        )}
       </div>
      </StyledBox>
      <StyledBox
       sx={{
        height: "100%",
        width: "100vw !important",
        overflowY: "scroll",
       }}
      >
       <Box className="ios-bottom-drawer">
        {/* small screen and mobile options  */}
        <div className="drawer-header-bottom-drawer"></div>
        {!!stormOptions.length && (
         <div className="storm-options-container-ios">
          <div
           className={!!checked ? `option-row-item-compare` : `option-row-item`}
          >
           {stormOptions.map((opt, idx) => (
            <StormScenario
             key={`opt1-${idx}`}
             number={opt.number}
             aB={opt.aB}
             title={opt.title}
             options={opt.options}
             info={opt.info}
             scenarioContainerClassname={"scenario-container-bottom-drawer"}
             thunk={opt.thunk}
             stateKey={opt.stateKey}
             switchCase={opt.switchCase}
             availableKeyName={opt.availableKeyName}
             btnClick={btnClickOne}
             reductionState={reductionStateOne}
            />
           ))}
          </div>
          {/* compare two scenarios  */}
          {!!checked && (
           <div
            className={
             !!checked ? `option-row-item-compare` : `option-row-item`
            }
           >
            {comparedStormScenarioConfig.map((opt, idx) => (
             <StormScenario
              key={`opt2-${idx}`}
              number={opt.number}
              aB={opt.aB}
              title={opt.title}
              options={opt.options}
              info={opt.info}
              scenarioContainerClassname={"scenario-container-compare-mobile"}
              thunk={opt.thunk}
              stateKey={opt.stateKey}
              switchCase={opt.switchCase}
              availableKeyName={opt.availableKeyName}
              btnClick={btnClickTwo}
              reductionState={reductionStateTwo}
             />
            ))}
           </div>
          )}
         </div>
        )}
       </Box>
      </StyledBox>
     </SwipeableDrawer>
    </Root>
   </div>
  </>
 );
};
export default SidebarMobileView;
